document.addEventListener( 'DOMContentLoaded', () => {
	const headers = document.querySelectorAll( '.accordion-repeater-header' );
	// Exit early if no .accordion-repeater-header elements are found
	if ( headers.length === 0 ) return;
	// Add click event listeners to accordion headers
	headers.forEach( header => {
		header.addEventListener( 'click', function () {
			const content = this.nextElementSibling;
			const isOpen = content.style.display === 'block';
			content.style.display = isOpen ? 'none' : 'block';
			this.classList.toggle( 'selected', !isOpen );
			headers.forEach( otherHeader => {
				if ( otherHeader !== this ) {
					const otherContent = otherHeader.nextElementSibling;
					otherContent.style.display = 'none'; // Hide other contents
					otherHeader.classList.remove( 'selected' );
				}
			} );
		} );
	} );
} );